import "./tours_list.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    window._tours_list_update_click_subscribe = () => {
      jQuery(".tours_list_filter_item").on("click", () => {
        const grid = jQuery("#tours_grid");
        if (grid) {
          grid.append("<div class='loader'></div>");
        }
      });
    };
    window._tours_list_update_click_subscribe();
  },
  false
);
